import { connect } from 'react-redux'
import FeatureFlagsPanel from './FeatureFlagsPanel'
import * as actions from '../../dataStore/actions'
import setupActions from '../../dataStore/actions/setup/setupActions'

const mapStateToProps = state => ({
  featureFlags: state.config.featureFlags
})

const mapDispatchToProps = dispatch => ({
  setFeatureFlag: (feature, value) => dispatch(setupActions.storeFeatureFlagState(feature, value))
})

export default connect(mapStateToProps, mapDispatchToProps)(FeatureFlagsPanel)
